module.exports = __webpack_public_path__ + "static/media/map.93ab817c.svg";